import { getFormattedTime } from './get-time-from-timestamp';

export const getDayFromTimestamp = (timestamp: number) => {
  if (timestamp) {
    return getFormattedTime(timestamp);
  }
  return;
};
